Selector.View.QuestionListView = Backbone.View.extend(
/** @lends Selector.View.QuestionListView# */
{
	initialize: function() {

    	_.bindAll(this, "render");
        this.collection.on('reset',this.render);
        this.collection.on('change',this.render);
        
	},

    modelViews: [],

    /** Render function */
	render: function() {

	    var _this = this;

        this.modelViews = [];

        //allows app to be loaded on page without the DOM element being present
        this.setElement($(".e_selector_questions"));

        var fragment = document.createDocumentFragment(),
            count = 0;

        this.collection.each(function (model) {
            if (model.get("CURRENT")) {
                model.set("COUNT", ++count);
                var modelView = new Selector.View.QuestionView({model: model});
                fragment.appendChild(modelView.render().el);
                _this.modelViews.push(modelView);
            }
        }, this);

		this.$el.html(fragment);

        if (ele.uri.getParameterByName(window.location.href, "sendEvents")) {
            window.parent.document.dispatchEvent(new CustomEvent('resizeIframe'));
        }

		return this;
	}

});